/**
 * Swiper 8.2.5
 * @url : https://swiperjs.com/api/
 */
// import Swiper JS
// core version + navigation, pagination modules:
import Swiper, { Navigation, Keyboard, Pagination, FreeMode } from 'swiper';

// Load Swiper with Drupal BigPipe Support
(function ($, Drupal) {
  Drupal.behaviors.LoadSwiper = {
    attach: function (context, settings) {
      /**
       * Swiper default
       */
      const Swipers = context.querySelectorAll('.js-swiper');
      if (Swipers.length) {
        for (const swiper of Swipers) {
          // Swiper instance
          const swiperInstance = new Swiper(swiper.querySelector('.swiper'), {
            modules: [Navigation, Keyboard],
            slidesPerView: 'auto',
            speed: 700,
            navigation: {
              nextEl: swiper.querySelector('.swiper-button-next'),
              prevEl: swiper.querySelector('.swiper-button-prev'),
            },
            keyboard: true,
            init: false,
          });

          // Init only if there is 2 or more slides
          const nbSlides = swiper.querySelectorAll('.swiper-slide');

          if (nbSlides.length > 1) swiperInstance.init();
        }
      }

      /**
       * Swiper freemode
       */
      const SwipersFree = Array.from(
        document.getElementsByClassName('js-swiper-freemode')
      );
      if (SwipersFree.length) {
        for (const swiper of SwipersFree) {
          // Swiper instance
          const swiperFreemodeInstance = new Swiper(
            swiper.querySelector('.swiper-free-mode'),
            {
              modules: [Navigation, Pagination, FreeMode, Keyboard],
              slidesPerView: 'auto',
              centeredSlides: Foundation.MediaQuery.current !== 'small',
              grabCursor: true,
              freeMode: true,
              spaceBetween: Foundation.MediaQuery.current === 'small' ? 16 : 32,
              speed: 700,
              navigation: {
                nextEl: swiper.querySelector('.swiper-button-next'),
                prevEl: swiper.querySelector('.swiper-button-prev'),
              },
              keyboard: true,
              init: false,
            }
          );

          // Init only if there is 2 or more slides
          const nbSlides = Array.from(
            swiper.getElementsByClassName('swiper-slide')
          );

          if (nbSlides.length > 1) swiperFreemodeInstance.init();
        }
      }
    },
  };
})(jQuery, Drupal);
